import { Box, Divider } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import React from 'react';
import {
  carbonNeutralIcon,
  helpCenterUrl,
  localSupportIcon,
  returnExchangePolicyHelpUrl,
  securePaymentIcon,
  securePaymentsHelpUrl,
  shippingHelpUrl,
  shippingIcon,
  TrustSignal,
  TrustSignalProps,
} from '../../../../components/TrustSignal';
import styles from './TrustSignalsGroup.module.scss';

export const messages = defineMessages({
  freeReturn: {
    defaultMessage: 'Free Return',
  },
  freeReturnDescription: {
    defaultMessage: 'Exchange or money back guarantee for all orders',
  },
  securePayment: {
    defaultMessage: 'Secure Payments',
  },
  securePaymentDescription: {
    defaultMessage: '100% Secure Payment with 256-bit SSL encryption',
  },
  worldWideShipping: {
    defaultMessage: 'Worldwide Shipping',
  },
  worldWideShippingDescription: {
    defaultMessage: 'Available as standard or express delivery',
  },
  localSupport: {
    defaultMessage: 'Local Support',
  },
  localSupportDescription: {
    defaultMessage: '24/7 Dedicated support',
  },
  learnMore: {
    defaultMessage: 'Learn more',
  },
  trustSignals: {
    defaultMessage: 'Trust signals',
  },
});

export const TrustSignalsGroup = () => {
  const intl = useIntl();
  const [{ locale }] = useUserInfo<UserInfo>();

  const learnMoreText = intl.formatMessage(messages.learnMore);
  const trustSignalsText = intl.formatMessage(messages.trustSignals);

  const signals: TrustSignalProps[] = [
    {
      image: shippingIcon,
      imageAlt: intl.formatMessage(messages.worldWideShipping),
      title: intl.formatMessage(messages.worldWideShipping),
      description: intl.formatMessage(messages.worldWideShippingDescription),
      link: shippingHelpUrl(locale),
      linkText: learnMoreText,
    },
    {
      image: securePaymentIcon,
      imageAlt: intl.formatMessage(messages.securePayment),
      title: intl.formatMessage(messages.securePayment),
      description: intl.formatMessage(messages.securePaymentDescription),
      link: securePaymentsHelpUrl(locale),
      linkText: learnMoreText,
    },
    {
      image: carbonNeutralIcon,
      imageAlt: intl.formatMessage(messages.freeReturn),
      title: intl.formatMessage(messages.freeReturn),
      description: intl.formatMessage(messages.freeReturnDescription),
      link: returnExchangePolicyHelpUrl(locale),
      linkText: learnMoreText,
    },
    {
      image: localSupportIcon,
      imageAlt: intl.formatMessage(messages.localSupport),
      title: intl.formatMessage(messages.localSupport),
      description: intl.formatMessage(messages.localSupportDescription),
      link: helpCenterUrl(locale),
      linkText: learnMoreText,
    },
  ];

  return (
    <>
      <Divider marginBottom="m" />
      <Box
        className={styles.wrapper}
        element="ul"
        aria-label={trustSignalsText}
      >
        {signals.map((signal) => (
          <TrustSignal
            key={signal.title}
            image={signal.image}
            imageAlt={signal.imageAlt}
            title={signal.title}
            description={signal.description}
            link={signal.link}
            linkText={signal.linkText}
          />
        ))}
      </Box>
    </>
  );
};
